import dynamic from 'next/dynamic';
import { MetaDataVideo } from 'components/SEO/Video';
import { TVideoIframe } from 'types/TVideoIframe';

const VideoIframe = dynamic(() => import('../VideoIframe/VideoIframe'), {
  ssr: false,
});

const VideoIframeWrapper = ({
  videoLocation,
  videoOrientation = 'horizontal',
  videoRefId,
  autoplay = false,
  controls = true,
  loop = false,
  seoData,
  recommendedYouTubeVideos = false,
}: TVideoIframe) => {
  return (
    <>
      <MetaDataVideo
        name={seoData?.name || null}
        contentUrl={seoData?.contentUrl || null}
        description={seoData?.description || null}
        duration={seoData?.duration || null}
        embedUrl={seoData?.embedUrl || null}
        thumbnailUrl={seoData?.thumbnailUrl || null}
        uploadDate={seoData?.uploadDate || null}
      />
      <VideoIframe
        videoLocation={videoLocation}
        videoOrientation={videoOrientation}
        videoRefId={videoRefId}
        autoplay={autoplay}
        controls={controls}
        loop={loop}
        seoData={seoData}
        recommendedYouTubeVideos={recommendedYouTubeVideos}
      />
    </>
  );
};

export default VideoIframeWrapper;
